module.exports = __webpack_public_path__ + "media/AdaptivePill-tutorial.ea788ba5.mp4";